import { Bars3Icon, TrashIcon } from "@heroicons/react/24/outline";
import IconBtn from "../../ui/IconBtn";
import SectionCreator from "../../line-pages/edit/SectionCreator";
import { ICityPageSectionEditDto } from "../../../interfaces/endpoints/ICityPage";

interface Props {
  index: number;
  section: ICityPageSectionEditDto;
  onDragStart: (e: React.DragEvent) => void;
  onDragOver: (e: React.DragEvent) => void;
  onDrop: (e: React.DragEvent) => void;
  onDelete: () => void;
}

const SectionItem = (props: Props) => (
  <div
    draggable
    onDragStart={props.onDragStart}
    onDragOver={props.onDragOver}
    onDrop={props.onDrop}
    className="mb-4 border rounded-lg p-4"
  >
    <div className="flex items-center justify-between mb-2">
      <div className="flex items-center gap-2">
        <Bars3Icon className="w-5 h-5 text-gray-400 cursor-move" />
        <span className="font-medium text-sm">
          Seksioni {props.index + 1}
        </span>
      </div>
      <IconBtn onClick={props.onDelete}>
        <TrashIcon className="w-5 h-5 text-red-500" />
      </IconBtn>
    </div>
    <SectionCreator
      section={props.section}
      sectionIndex={props.index}
    />
  </div>
);

export default SectionItem;
